/* eslint-disable import/no-named-as-default */
// #region Imports
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

import AtualizacaoDados from './AtualizacaoDados';
import FormConsultaDados from './forms/FormConsultaDados';
import FormOutrasSolicitacoes from './forms/FormOutrasSolicitacoes';
import useStyles from './styles';

import { appColors } from '../../AppTheme';
import LGPD from '../../consts/text/lgpd';
import TabPanel from '../../containers/TabPanel';
import { getParameterByName } from '../../library/utils';

// #endregion

const { TITLE, PARAGRAPH, TABS } = LGPD;

function Lgpd() {
  const navigate = useNavigate();
  const styles = useStyles();
  const [urlToken, setUrlToken] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  const handleToken = useCallback(() => {
    const token = getParameterByName('token');

    if (token) {
      setUrlToken(encodeURIComponent(token));
    } else {
      navigate('/home');
    }
  }, [navigate]);

  useEffect(() => {
    handleToken();
  }, [handleToken]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    urlToken && (
      <Container maxWidth="md" style={{ minHeight: 'calc(100vh - 156px)' }}>
        <Box
          bgcolor={appColors.alternativeGray}
          color={appColors.gray}
          padding="1em 2%"
        >
          <Typography variant="h4">{TITLE}</Typography>
          <br />
          <Typography variant="subtitle2">{PARAGRAPH}</Typography>
        </Box>
        <AppBar position="static" color="default" className={styles.appBar}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            selectionFollowsFocus
          >
            {Object.values(TABS).map((label, index) => (
              <Tab key={index} {...{ label }} className={styles.tab} />
            ))}
          </Tabs>
        </AppBar>
        <TabPanel value={tabValue} index={0}>
          <FormConsultaDados token={urlToken} />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AtualizacaoDados />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <FormOutrasSolicitacoes token={urlToken} />
        </TabPanel>
      </Container>
    )
  );
}

export default Lgpd;
